import { render, staticRenderFns } from "./EntranceSelectionPreTest.vue?vue&type=template&id=5a90fa2f&scoped=true&lang=pug&"
import script from "./EntranceSelectionPreTest.vue?vue&type=script&lang=ts&"
export * from "./EntranceSelectionPreTest.vue?vue&type=script&lang=ts&"
import style0 from "./EntranceSelectionPreTest.vue?vue&type=style&index=0&id=5a90fa2f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90fa2f",
  null
  
)

export default component.exports